module.exports = __webpack_public_path__ + "static/media/img__photostory.0a17ea78.png";